"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.execute = void 0;
var child_process_1 = require("./child-process");
Object.defineProperty(exports, "execute", { enumerable: true, get: function () { return child_process_1.execute; } });
//# sourceMappingURL=index.js.map